import { motion } from 'motion/react'
import { cn } from '@/lib/utils'
import { ComponentProps } from 'react'

function Skeleton({ className, ...props }: ComponentProps<typeof motion.div>) {
  return <motion.div className={cn('animate-pulse rounded-md bg-layer-3', className)} {...props} />
}

export { Skeleton }
